<template>
  <li :class="['list-group-item text-left gcc-cohort', {'is-selected': cohortSelected}]"  @click.stop="toggleCohortSelection">

    <span class="badge">{{ cohort.UserCount }}</span>

    <i class="fas fa-check"></i>

    {{ cohort.CohortName | excerpt(20) }}

    <span class="badge" data-toggle="tooltip" data-placement="left" title="# of current enrolments">{{ `${cohortStats}` }}</span>
  </li>
</template>

<script>
import filter from 'lodash/filter'
export default {
  name: 'GccCohort',

  props: {
    cohortObj: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      cohort: this.cohortObj,
      cohortSelected: this.isSelected
    }
  },

  computed: {
    cohortStats () {
      let enrollmentCount = 0
      switch (this.currDashboardTabSelection) {
        default:
        case 1:
          enrollmentCount = filter(this.cohort.DashboardDataList, (obj) => {
            return !obj.isUnEnrolled
          }).length
          break
        case 2:
          enrollmentCount = this.cohortObj.TotalUsers
          break
      }
      return enrollmentCount
    },
    currDashboardTabSelection: {
      get: function () {
        return this.$store.getters.currDashboardTabSelection
      }
    }
  },

  beforeDestroy () {
    this.eventHub.$off('deselectAllCourses')
    this.eventHub.$off('selectAllCourses')
  },

  mounted () {
    this.eventHub.$on('deselectAllCourses', () => {
      this.setCohortSelection(false)
    })
    this.eventHub.$on('selectAllCourses', () => {
      this.setCohortSelection(true)
    })
  },

  methods: {
    toggleCohortSelection () {
      this.cohortSelected = !this.cohortSelected
      this.eventHub.$emit('cohort-selection-toggled', this.cohort.GroupCourseMasterId, this.cohort.CohortId, this.cohortSelected)
    },

    setCohortSelection (isSelected) {
      this.cohortSelected = isSelected
      this.eventHub.$emit('cohort-selection-toggled', this.cohort.GroupCourseMasterId, this.cohort.CohortId, isSelected)
    }
  },

  watch: {
    isSelected: function (newVal, oldVal) {
      this.cohortSelected = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.gcc-cohort-list .gcc-cohort {
  padding: 0.5em 0.65em;
  font-family: 'Source Sans Pro', 'Avenir', 'Helvetica', sans-serif;
  color: #27345B;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}

.gcc-cohort-list .gcc-cohort svg.svg-inline--fa.fa-check {
  color: #C8C8C8;
  margin-right: 0.5em;
  transition: color 100ms ease-in-out;
}

.gcc-cohort-list .gcc-cohort.is-selected svg.svg-inline--fa.fa-check {
  color: #00BF00;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard_v2/GCCFilterCohort.vue